import { Node as ProseNode } from 'prosemirror-model'
import { NodeWithPos } from 'prosemirror-utils'

export const findInlineTodoById = (parentNode: ProseNode, todoId: number): NodeWithPos | null => {
  let foundNode: NodeWithPos | null = null
  parentNode.descendants((node, pos) => {
    if (node.attrs.todoId === todoId) {
      foundNode = { node, pos }
      return false
    }
  })
  return foundNode
}
